module.exports = __webpack_public_path__ + "static/media/cover.af7c7cff.png";